export enum WebSocketEventTypes {
  CLOSE,
  ERROR,
  OPEN,
  MESSAGE
}

export enum WebSocketMessageMode {
  CALL = 'call',
  STATUS = 'status',
  MESSAGE = 'message',
  ECG = 'ecg'
}
